export default {
  "pl": {
    "countries": {
      "ABW": "Aruba",
      "AFG": "Afganistan",
      "AFI": "Francuskie Terytorium Afarów i Isów",
      "AGO": "Angola",
      "AIA": "Anguilla",
      "ALA": "Wyspy Alandzkie",
      "ALB": "Albania",
      "AND": "Andora",
      "ANT": "Antyle Holenderskie",
      "ARE": "Zjednoczone Emiraty Arabskie",
      "ARG": "Argentyna",
      "ARM": "Armenia",
      "ASM": "Samoa Amerykańskie",
      "ATA": "Antarktyda",
      "ATB": "Brytyjskie Terytorium Antarktyczne",
      "ATF": "Francuskie Terytoria Południowe",
      "ATG": "Antigua i Barbuda",
      "ATN": "Ziemia Królowej Maud",
      "AUS": "Australia",
      "AUT": "Austria",
      "AZE": "Azerbejdżan",
      "BDI": "Burundi",
      "BEL": "Belgia",
      "BEN": "Benin",
      "BES": "Bonaire, Sint Eustatius i Saba",
      "BFA": "Burkina Faso",
      "BGD": "Bangladesz",
      "BGR": "Bułgaria",
      "BHR": "Bahrajn",
      "BHS": "Bahamy",
      "BIH": "Bośnia i Hercegowina",
      "BLM": "Saint-Barthélemy",
      "BLR": "Białoruś",
      "BLZ": "Belize",
      "BMU": "Bermudy",
      "BOL": "Boliwia",
      "BRA": "Brazylia",
      "BRB": "Barbados",
      "BRN": "Brunei Darussalam",
      "BTN": "Bhutan",
      "BUR": "Birma",
      "BVT": "Wyspa Bouveta",
      "BWA": "Botswana",
      "BYS": "Białoruś",
      "CAF": "Republika Środkowoafrykańska",
      "CAN": "Kanada",
      "CCK": "Wyspy Kokosowe",
      "CHE": "Szwajcaria",
      "CHL": "Chile",
      "CHN": "Chiny",
      "CIV": "Wybrzeże Kości Słoniowej",
      "CMR": "Kamerun",
      "COD": "Kongo",
      "COG": "Kongo",
      "COK": "Wyspy Cooka",
      "COL": "Kolumbia",
      "COM": "Komory",
      "CPV": "Republika Zielonego Przylądka",
      "CRI": "Kostaryka",
      "CSK": "Czechosłowacja",
      "CTE": "Kanton i Enderbury",
      "CUB": "Kuba",
      "CUW": "Curaçao",
      "CXR": "Wyspa Bożego Narodzenia",
      "CYM": "Kajmany",
      "CYP": "Cypr",
      "CZE": "Czechy",
      "DDR": "Niemcy Wschodnie",
      "DEU": "Niemcy",
      "DHY": "Dahomej",
      "DJI": "Dżibuti",
      "DMA": "Dominika",
      "DNK": "Dania",
      "DOM": "Dominikana",
      "DZA": "Algieria",
      "ECU": "Ekwador",
      "EGY": "Egipt",
      "ERI": "Erytrea",
      "ESH": "Sahara Zachodnia",
      "ESP": "Hiszpania",
      "EST": "Estonia",
      "ETH": "Etiopia",
      "FIN": "Finlandia",
      "FJI": "Fidżi",
      "FLK": "Falklandy",
      "FRA": "Francja",
      "FRO": "Wyspy Owcze",
      "FSM": "Mikronezja",
      "FXX": "Francja metropolitarna",
      "GAB": "Gabon",
      "GBR": "Wielka Brytania",
      "GEL": "Wyspy Gilberta",
      "GEO": "Gruzja",
      "GGY": "Guernsey",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GIN": "Gwinea",
      "GLP": "Gwadelupa",
      "GMB": "Gambia",
      "GNB": "Gwinea Bissau",
      "GNQ": "Gwinea Równikowa",
      "GRC": "Grecja",
      "GRD": "Grenada",
      "GRL": "Grenlandia",
      "GTM": "Gwatemala",
      "GUF": "Gujana Francuska",
      "GUM": "Guam",
      "GUY": "Gujana",
      "HKG": "Hongkong",
      "HMD": "Wyspy Heard i McDonalda",
      "HND": "Honduras",
      "HRV": "Chorwacja",
      "HTI": "Haiti",
      "HUN": "Węgry",
      "HVO": "Górna Wolta",
      "IDN": "Indonezja",
      "IMN": "Wyspa Man",
      "IND": "Indie",
      "IOT": "Brytyjskie Terytorium Oceanu Indyjskiego",
      "IRL": "Irlandia",
      "IRN": "Iran",
      "IRQ": "Irak",
      "ISL": "Islandia",
      "ISR": "Izrael",
      "ITA": "Włochy",
      "JAM": "Jamajka",
      "JEY": "Jersey",
      "JOR": "Jordania",
      "JPN": "Japonia",
      "JTN": "Johnston",
      "KAZ": "Kazachstan",
      "KEN": "Kenia",
      "KGZ": "Kirgistan",
      "KHM": "Kambodża",
      "KIR": "Kiribati",
      "KNA": "Saint Christopher-Nevis-Anguilla",
      "KOR": "Korea Południowa",
      "KWT": "Kuwejt",
      "LAO": "Laos",
      "LBN": "Liban",
      "LBR": "Liberia",
      "LBY": "Libia",
      "LCA": "Saint Lucia",
      "LIE": "Liechtenstein",
      "LKA": "Sri Lanka",
      "LSO": "Lesotho",
      "LTU": "Litwa",
      "LUX": "Luksemburg",
      "LVA": "Łotwa",
      "MAC": "Makau",
      "MAF": "Saint-Martin (część francuska)",
      "MAR": "Maroko",
      "MCO": "Monako",
      "MDA": "Mołdawia",
      "MDG": "Madagaskar",
      "MDV": "Malediwy",
      "MEX": "Meksyk",
      "MHL": "Wyspy Marshalla",
      "MID": "Midway",
      "MKD": "Macedonia",
      "MLI": "Mali",
      "MLT": "Malta",
      "MMR": "Mjanma",
      "MNE": "Czarnogóra",
      "MNG": "Mongolia",
      "MNP": "Mariany Północne",
      "MOZ": "Mozambik",
      "MRT": "Mauretania",
      "MSR": "Montserrat",
      "MTQ": "Martynika",
      "MUS": "Mauritius",
      "MWI": "Malawi",
      "MYS": "Malezja",
      "MYT": "Majotta",
      "NAM": "Namibia",
      "NCL": "Nowa Kaledonia",
      "NER": "Niger",
      "NFK": "Norfolk",
      "NGA": "Nigeria",
      "NHB": "Nowe Hebrydy",
      "NIC": "Nikaragua",
      "NIU": "Niue",
      "NLD": "Holandia",
      "NOR": "Norwegia",
      "NPL": "Nepal",
      "NRU": "Nauru",
      "NTZ": "Terytorium neutralne",
      "NZL": "Nowa Zelandia",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PAN": "Panama",
      "PCI": "Powiernicze Wyspy Pacyfiku",
      "PCN": "Pitcairn",
      "PCZ": "Strefa Kanału Panamskiego",
      "PER": "Peru",
      "PHI": "Filipiny",
      "PHL": "Filipiny",
      "PLW": "Palau",
      "PNG": "Papua-Nowa Gwinea",
      "POL": "Polska",
      "PRI": "Portoryko",
      "PRK": "Korea Północna",
      "PRT": "Portugalia",
      "PRY": "Paragwaj",
      "PSE": "Okupowane terytoria palestyńskie",
      "PUS": "Różne Wyspy Pacyfiku Stanów Zjednoczonych",
      "PYF": "Polinezja Francuska",
      "QAT": "Katar",
      "REU": "Reunion",
      "RHO": "Rodezja Południowa",
      "ROU": "Rumunia",
      "RUS": "Rosja",
      "RWA": "Rwanda",
      "SAU": "Arabia Saudyjska",
      "SCG": "Serbia i Czarnogóra",
      "SDN": "Sudan",
      "SEN": "Senegal",
      "SGP": "Singapur",
      "SGS": "Georgia Południowa i Sandwich Południowy",
      "SHN": "Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha",
      "SJM": "Svalbard i Jan Mayen",
      "SKM": "Sikkim",
      "SLB": "Wyspy Salomona",
      "SLE": "Sierra Leone",
      "SLV": "Salwador",
      "SMR": "San Marino",
      "SOM": "Somalia",
      "SPM": "Saint-Pierre i Miquelon",
      "SRB": "Serbia",
      "SSD": "Sudan Południowy",
      "STP": "Wyspy Świętego Tomasza i Książęca",
      "SUN": "ZSRR",
      "SUR": "Surinam",
      "SVK": "Słowacja",
      "SVN": "Słowenia",
      "SWE": "Szwecja",
      "SWZ": "Suazi",
      "SXM": "Sint Maarten (część holenderska)",
      "SYC": "Seszele",
      "SYR": "Syria",
      "TCA": "Turks i Caicos",
      "TCD": "Czad",
      "TGO": "Togo",
      "THA": "Tajlandia",
      "TJK": "Tadżykistan",
      "TKL": "Tokelau",
      "TKM": "Turkmenistan",
      "TLS": "Timor Wschodni",
      "TMP": "Timor Portugalski",
      "TON": "Tonga",
      "TTO": "Trynidad i Tobago",
      "TUN": "Tunezja",
      "TUR": "Turcja",
      "TUV": "Tuwalu",
      "TWN": "Tajwan (prowincja Chin)",
      "TZA": "Tanzania",
      "UGA": "Uganda",
      "UKR": "Ukraina",
      "UMI": "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
      "URY": "Urugwaj",
      "USA": "Stany Zjednoczone",
      "UZB": "Uzbekistan",
      "VAT": "Watykan",
      "VCT": "Saint Vincent i Grenadyny",
      "VDR": "Wietnam Północny",
      "VEN": "Wenezuela",
      "VGB": "Brytyjskie Wyspy Dziewicze",
      "VIR": "Wyspy Dziewicze Stanów Zjednoczonych",
      "VNM": "Wietnam Południowy",
      "VUT": "Vanuatu",
      "WAK": "Wake",
      "WLF": "Wallis i Futuna",
      "WSM": "Samoa",
      "XXX": "Nieznane",
      "YEM": "Jemeńska Republika Arabska",
      "YMD": "Ludowo-Demokratyczna Republika Jemenu",
      "YUG": "Jugosławia",
      "ZAF": "Republika Południowej Afryki",
      "ZAR": "Zair",
      "ZMB": "Zambia",
      "ZWE": "Zimbabwe"
    }
  }
}
